import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom';
import CategoriesSection from '../../../components/store/reusable/category/CategoriesSection';
import { useStoreReviews } from '../../../hooks/store/review';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import Pagination from '../../../components/ui/Pagination';
import ReviewsTable from '../../../components/store/reviews/ReviewsTable'
import EmptyData from '../../../components/ui/EmptyData';
import { formatNumber } from '../../../utils/formatNumber';

function StoreReviewOverView() {
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {t} = useTranslation();
    const [searchParams,setSearchParams] = useSearchParams();
    const rate = searchParams.get("category");
    const pageQuery = Number(searchParams.get('page')) || 1;
    const categories=[{id:5,name:formatNumber(5)},{id:4,name:formatNumber(4)},{id:3,name:formatNumber(3)},{id:2,name:formatNumber(2)},{id:1,name:formatNumber(1)}];
    const {data:reviews,isError,isLoading} = useStoreReviews({rating:rate?+rate:undefined,storeId:numericStoreId});

     const handlePagination = (page: number) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', page.toString());
        setSearchParams(newParams);
    };


  return (
    <Layout title={t('owner_sidebar.Customers_Reviews')} headline=''>
        <CategoriesSection
        selectedCategory={rate?rate:""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={"add-offer"}
        buttonLabel='add_new_offer'
        showAdd={false}
        notShowAddButton={true}
      />
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
      {
        reviews &&
        (reviews?.data.length === 0 
        ?
        <EmptyData/> 
        :
        <>
        <ReviewsTable reviews={reviews.data}/>
        <Pagination
          currentPage={pageQuery}
          totalPages={reviews?.totalPages||0}
          handlePagination={handlePagination}
        />
        </>
        )
      }
    </Layout>
  )
}

export default StoreReviewOverView